<template>
  <v-card>
    <GenericListTable
      :parentID="this.parentID"
      :title="`Groups`"
      :headers="[
          { text: 'ID', value: 'id' },
          { text: 'Group Code', value: 'co_groupcode' },
          { text: 'Group Description', value: 'co_groupdesc' },
          { text: 'Group Name', value: 'co_groupname' }
        ]"
      :url="`/manifest/groupinfo`"
      :apiResponseField="`groupinfolist`"
      :onClickRoute="`GroupSingle`"
      :onClickParams="getOnClickParams"
      :editable="true"
      :saveUrl="`/manifest/groupinfo?ids_to_update=`">
    </GenericListTable>
  </v-card>
</template>

<script>
import GenericListTable from '@/components/Common/GenericListTable'

export default {
  name: 'GroupListTable',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.id
      }
    }
  }
}
</script>
